import {Power0} from 'gsap';
let fullAnimation = gsap.timeline({paused: true});
const init = (el) => {
	const slow = 0.5;
	const time = 2.25;
	const time2 = 2.75;

	const parent = el;
	const easeAnimate = 'Sine.easeInOut';

	const el1 = parent.querySelector('.scheme-2-2__inner--1');
	const el2 = parent.querySelector('.scheme-2-2__inner--2');
	const el3 = parent.querySelector('.scheme-2-2__inner--3');
	const el4 = parent.querySelector('.scheme-2-2__inner--4');
	const el6 = parent.querySelector('.scheme-2-2__inner--6');
	const el7 = parent.querySelector('.scheme-2-2__inner--7');
	const el8 = parent.querySelector('.scheme-2-2__inner--8');
	const tm = gsap.timeline();
	fullAnimation.add(tm.play());

	tm
		.to(el1, {
			ease: easeAnimate,
			duration: time2,
			x: 41,
			y: -4,
		}, 0.75)
		.to(el1, {
			ease: easeAnimate,
			duration: time2,
			x: 13,
			y: -5,
			repeat: -1,
			yoyo: true,
		})
		.to(el2, {
			ease: easeAnimate,
			duration: time2,
			x: -20,
			y: 12,
		}, 0)
		.to(el2, {
			ease: easeAnimate,
			duration: time2,
			x: 10,
			y: 0,
			repeat: -1,
			yoyo: true,
		})
		.to(el3, {
			ease: easeAnimate,
			duration: time2,
			x: -60,
			y: 20,
		}, 0.45)
		.to(el3, {
			ease: easeAnimate,
			duration: time2,
			x: -121,
			y: 38.8,
			repeat: -1,
			yoyo: true,
		})
		.to(el4, {
			ease: easeAnimate,
			duration: time,
			x: -90,
			y: 20,
		}, 0)
		.to(el4, {
			ease:easeAnimate,
			duration: time + slow,
			x: -70,
			y: 13,
			repeat: -1,
			yoyo: true,
		})
		.to(el6, {
			ease: easeAnimate,
			duration: time,
			opacity: 0.5,
		}, 0)
		.to(el6, {
			ease: easeAnimate,
			duration: time,
			opacity: 1,
			repeat: -1,
			yoyo: true,
		})
		.to(el7, {
			ease: easeAnimate,
			duration: 1.8,
			x: '5em',
			y: '1em',
		}, 0)
		.to(el7, {
			ease: easeAnimate,
			duration: 1.3 + slow,
			x: '5em',
			y: '2em',
			repeat: -1,
			yoyo: true,
		})
		.to(el8, {
			ease: easeAnimate,
			duration: 2,
			x: '5em',
			y: '1em',
		}, 0)
		.to(el8, {
			ease: easeAnimate,
			duration: 1.5 + slow,
			x: '5em',
			y: '2em',
			repeat: -1,
			yoyo: true,
		});
};

const play = () => {
	if (fullAnimation && fullAnimation.paused()) {
		fullAnimation.play();
	}
};

const pause = () => {
	if (fullAnimation && !fullAnimation.paused()) {
		fullAnimation.pause();
	}
};

export default {
	init,
	play,
	pause,
};
